var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { forwardRef } from 'react';
import { Form } from 'react-bootstrap';
export const RadioInput = forwardRef((_a, ref) => {
    var { label, type, options } = _a, rest = __rest(_a, ["label", "type", "options"]);
    return (_jsx(Form.Group, Object.assign({ className: 'radio-input' }, { children: options === null || options === void 0 ? void 0 : options.map(({ label: optionLabel, value }) => {
            var _a;
            return (_createElement(Form.Check, Object.assign({}, rest, { key: `${rest.name}-${optionLabel}`, id: `${rest.name}-${value}`, ref: ref, type: 'radio', value: value, label: optionLabel, checked: ((_a = rest.value) === null || _a === void 0 ? void 0 : _a.toString()) === (value === null || value === void 0 ? void 0 : value.toString()) })));
        }) })));
});
RadioInput.displayName = 'RadioInput';
